module.exports = __webpack_public_path__ + "images/xl-hunan.jpg?cc502cfdd7d6447e80a3ba1f15b388be";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/xl-hunan.jpg
// module id = 208
// module chunks = 1